import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { AlertTriangle, LogIn } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
import { env } from '../env';
import { red } from '../theme/theme';

export function LoginPage() {
  const { mode, loginDev, loginMsal, status, error } = useAuth();
  const [email, setEmail] = useState('');
  const busy = status === 'signingIn' || status === 'initializing';
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, background: `linear-gradient(160deg, #FFFFFF 0%, ${red[50]} 100%)` }}>
      <Card sx={{ width: '100%', maxWidth: 440 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="overline" sx={{ color: 'primary.main' }}>
            COTINGA
          </Typography>
          <Typography variant="h3" component="h1" sx={{ mb: 1 }}>
            Autopilot
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            KI-gestützte Beantwortung und Lösung von Nidus-Vorgängen. Der Zugang ist unabhängig von Ihrem Nidus-Login und muss für Autopilot freigeschaltet sein.
          </Typography>
          {error && (
            <Alert severity="error" icon={<AlertTriangle size={20} />} sx={{ mb: 2 }} role="alert">
              {error}
            </Alert>
          )}
          {mode === 'msal' ? (
            <Button variant="contained" size="large" fullWidth startIcon={<LogIn size={18} />} onClick={() => void loginMsal()} disabled={busy || status === 'error'}>
              Mit Microsoft anmelden
            </Button>
          ) : (
            <>
              <Alert severity="info" sx={{ mb: 2 }}>
                {env.mock ? 'Mock-Modus: Daten sind synthetisch, es wird nichts versendet.' : 'Entwicklungsmodus: Anmeldung mit lokalen Dev-Nutzern.'}
              </Alert>
              <Stack spacing={1.25}>
                {env.devUsers.map((u) => (
                  <Button key={u} variant="outlined" onClick={() => void loginDev(u)} disabled={busy} sx={{ justifyContent: 'flex-start' }} data-testid={`dev-login-${u.split('@')[0]}`}>
                    {u}
                  </Button>
                ))}
              </Stack>
              <Divider sx={{ my: 2.5 }}>oder</Divider>
              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (email.trim()) void loginDev(email.trim());
                }}
                sx={{ display: 'flex', gap: 1 }}
              >
                <TextField label="Dev-E-Mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
                <Button type="submit" variant="contained" disabled={busy || !email.trim()}>
                  Anmelden
                </Button>
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
